/**
 * Placeholder upcoming events until a merchant Events API exists.
 * Copy lives in locales under events.items.{id}.*
 */
export const EVENTS_PLACEHOLDER = [
    {
        id: 'live-music',
        date: '2026-10-04',
        time: '20:00',
    },
    {
        id: 'coffee-tasting',
        date: '2026-10-18',
        time: '18:30',
    },
    {
        id: 'private-dining',
        date: '2026-11-01',
        time: '19:00',
    },
];
